import React from 'react';
import { SortDirection, SortField } from '../TieredUnitCountTimelineContainer';
import { IActivePropertyTimesUnits } from '@llws/lift-entity-interfaces';

interface APTUTableProps {
  aptuData: IActivePropertyTimesUnits[];
  sortField: SortField;
  sortDirection: SortDirection;
  handleSort: (field: SortField) => void;
}

const APTUTable: React.FC<APTUTableProps> = ({
  aptuData,
  sortField,
  sortDirection,
  handleSort,
}) => {
  // Helper for sort indicators
  const renderSortIndicator = (field: SortField) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? ' ▲' : ' ▼';
  };

  // Helper for sortable column header
  const SortableHeader = ({ field, label }: { field: SortField, label: string }) => (
    <th
      style={{
        padding: '8px',
        border: '1px solid #ddd',
        textAlign: 'left',
        cursor: 'pointer',
        backgroundColor: sortField === field ? '#e6f2ff' : '#f5f5f5',
      }}
      onClick={() => handleSort(field)}
    >
      {label}{renderSortIndicator(field)}
    </th>
  );

  return (
    <div style={{ marginTop: '20px', overflowX: 'auto' }}>
      <h3>APTU Details ({aptuData.length} records)</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f5f5f5' }}>
            <SortableHeader field="id" label="ID" />
            <SortableHeader field="buildingId" label="Building ID" />
            <SortableHeader field="building.buildingName" label="Building Name" />
            <SortableHeader field="suiteTypeId" label="Suite Type ID" />
            <SortableHeader field="buildingBillingTypeId" label="Building Billing Type ID" />
            <SortableHeader field="startTime" label="Start Time" />
            <SortableHeader field="stopTime" label="Stop Time" />
            <SortableHeader field="activeUnits" label="Active Units" />
          </tr>
        </thead>
        <tbody>
          {aptuData.map(aptu => (
            <tr key={aptu.id}>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{aptu.id}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{aptu.buildingId}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{aptu.building?.buildingName || 'N/A'}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{aptu.suiteTypeId || 'N/A'}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{aptu.buildingBillingTypeId || 'N/A'}</td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                {aptu.startTime.substring(0, 10)}
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                {aptu.stopTime ? aptu.stopTime.substring(0, 10) : 'Active'}
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>{aptu.activeUnits}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default APTUTable;
